import { CompanyService } from '@cp/shared/data-access/company/company.service';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cp-compliance-lapsed-notification',
  templateUrl: './compliance-lapsed-notification.component.html',
  styleUrls: ['./compliance-lapsed-notification.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ComplianceLapsedNotificationComponent {
  public readonly qnUrl = `${this._companyService.qnUrl(
    'pwa',
  )}/shifts/shift-search`;

  constructor(private _companyService: CompanyService) {}
}
